export class SocialMedia {
  // Canonical channel keys (lowercase, mirroring public/icons/social/) and their display labels
  public static readonly typeLabels: Record<string, string> = {
    facebook: 'Facebook',
    instagram: 'Instagram',
    linkedin: 'LinkedIn',
    youtube: 'YouTube',
    tiktok: 'TikTok',
    whatsapp: 'WhatsApp',
    pinterest: 'Pinterest',
    x: 'X',
    website: 'Website',
    overig: 'Overig',
  };

  // Channels that have a brand icon in public/icons/social/
  private static readonly typesWithIcon: string[] = [
    'facebook',
    'instagram',
    'linkedin',
    'youtube',
    'tiktok',
    'whatsapp',
    'pinterest',
    'x',
  ];

  // Variants found in the back-end data that resolve to a canonical key
  private static readonly typeAliases: Record<string, string> = {
    twitter: 'x',
  };

  public type: string;
  public url: string;

  constructor(data: Partial<SocialMedia> = {}) {
    this.type = SocialMedia.normaliseType(data?.type);
    this.url = data?.url ?? '';
  }

  public static createFromApi(data: Partial<SocialMedia> = {}): SocialMedia {
    return new SocialMedia(data);
  }

  /** The back-end mixes casings ("linkedin", "linkedIn"), so keys are compared lowercased. */
  public static normaliseType(type?: string): string {
    const key = (type ?? '').toLowerCase();
    return SocialMedia.typeAliases[key] ?? key;
  }

  public static labelForType(type?: string): string {
    return SocialMedia.typeLabels[SocialMedia.normaliseType(type)] ?? type ?? '';
  }

  public static iconForType(type?: string): string | null {
    const key = SocialMedia.normaliseType(type);
    return SocialMedia.typesWithIcon.includes(key) ? `icons/social/${key}.svg` : null;
  }

  public processForApi(): Record<string, any> {
    return {
      type: this.type,
      url: this.url,
    };
  }
}
